module.exports = __webpack_public_path__ + "static/media/logo.273f40a9.svg";